import * as React from 'react'
import { classNames } from './helpers'

export interface HighlightProps {
  /**
   * Small eyebrow above the row heading, naming *why* this row is here (e.g.
   * "Highlight"). Translated by the caller — the styleguide ships no copy.
   */
  label: string;
  /**
   * The row itself — a {@link Showcase}. This component contributes only the
   * surrounding treatment, never the row's own heading or tiles.
   */
  children: React.ReactNode;
  className?: string;
}

/**
 * The editorial band that lifts one {@link Showcase} out of the stack of
 * catalogue rows around it.
 *
 * The browse page seats a promoted topic (`/api/3.0/content/topic/highlight`)
 * inside it: same scrolling-row component as every other row, wrapped in a
 * full-bleed tinted band with an eyebrow, so it reads as editorial rather than as
 * one more catalogue shelf.
 *
 * Purely presentational, and deliberately content-agnostic: it takes whatever row
 * it is given, so any pilet can promote a row without a new component. The band is
 * full-bleed on purpose — the inner row's own horizontal padding is dropped (see
 * Highlight.css) so its heading and first tile stay aligned with the ordinary rows
 * above and below.
 */
export function Highlight ({ label, children, className }: HighlightProps) {
  return (
    <section className={classNames('mlsg-highlight', className)}>
      <p className='mlsg-highlight__label'>{label}</p>
      {children}
    </section>
  )
}
